import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { deleteStoredValue, getStoredValue, hasStoredValue, storeValue } from "../localStorage";
import { VALID_BUDGET_LOCAL_STORAGE_VALUES } from "../../Pages/Budget/consts";
export var KEY_FIELD = 'OnboardingBudget';
export function deleteStoredBudget() {
  deleteStoredValue(KEY_FIELD);
}

// there is only ever one number stored for budget
export function getStoredBudget() {
  var maxValue = getStoredValue(KEY_FIELD);
  // make sure that it is a valid value
  if (maxValue.length === 1 && VALID_BUDGET_LOCAL_STORAGE_VALUES.includes(maxValue[0])) {
    return maxValue[0];
  }
  return '';
}
export function hasStoredBudget() {
  return hasStoredValue(KEY_FIELD);
}
export function storeBudgetValue(max) {
  storeValue(max, KEY_FIELD);
}